// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__QVG0n","header":"ReportDetails_header__R6FZa","title":"ReportDetails_title__2MJI-","left":"ReportDetails_left__1nRSF"};